import React, { useContext, useEffect, useState } from "react";
import { Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { LoaderContext, getContext } from "../../Helpers/Context/Context";
import {
  getUserRoleMappingData,
  CommonDropdownData,
  getUserRoleMappingExporttoExcel,
} from "../../Helpers/APIEndPoints/EndPoints";
import InputForm from "../../Components/InputForm/InputForm";
import axios from "axios";
import moment from "moment";
import fileDownload from "js-file-download";
import { APICall } from "../../Helpers/Network/APICalls";
import "./UserRoleMapping.css";
import DynamicGrid from "../../Components/DynamicGrid/DynamicGrid";
import SelectForm from "../../Components/SelectForm/SelectForm";
import { Collapse } from "react-bootstrap";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import ButtonComponent from "../../Components/ButtonForm/Button";
import { fetchAuthToken } from "../../Helpers/Network/OAuthHandler";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";

const UserRoleMappingDashboard = () => {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [dataCount, setDataCount] = React.useState<number>(0);
  const [dashboardPageSize, setDashboardPageSize] = React.useState<number>(10);
  const [searchText, setSearchText] = React.useState<string>("");
  const [sortDirection, setSortDirection] = useState("");
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [userRoleOptions, setUserRoleOptions] = useState([]);
  const [userRole, setUserRole] = useState<any>();
  const [unitCodeOptions, setUnitCodeOptions] = useState([]);
  const [unitCode, setUnitCode] = useState<any>();
  const [dashboardFilterOn, setDashboardFilterOn] = useState(false);

  let navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState([]);

  useEffect(() => {
    userRoleDropdownApiCall();
    getUnitCodeDropDownDataApiCall();
  }, []);

  useEffect(() => {
    getDashboardData("");
  }, [start, sortColumn, sortDirection, searchText, count]);

  const userRoleDropdownApiCall = async () => {
    const resp = await APICall(CommonDropdownData, {
      dropdownName: "userrole",
    });
    if (resp?.Data?.length > 0) {
      setUserRoleOptions(resp?.Data);
    }
  };
  const getUnitCodeDropDownDataApiCall = async () => {
    showLoader();

    let requestParams = {
      dropdownName: "unitcodedd",
    };
    const res = await APICall(CommonDropdownData, requestParams);

    if (res.Status === ApiStatus.OK && res.Data.length > 0) {
      let options = await res.Data;

      await setUnitCodeOptions(options);
    } else {
      await setUnitCodeOptions([]);
    }

    hideLoader();
  };
  const dashboardOptions = {
    showEmptyDataSourceMessage: true,
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [] as any[],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: false,
    responsive: "standard",
    onChangeRowsPerPage: () => {
      // num
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
      setStart(0);
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      setStart(0);
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };
  const dashboardGridColumns = [
    {
      name: "Id",
      label: "Id",
      options: {
        display: false,
      },
    },
    {
      name: "Name",
      label: "User",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "email",
      label: "Email",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "RoleName",
      label: "User Role",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "unitcodevalue",
      label: "Unit Code",
      options: {
        display: true,
        filter: true,
        sort: true,
      },
    },
    {
      name: "IsActive",
      label: "Active Status",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: { textAlign: "center" },
        }),
        setCellHeaderProps: () => ({
          style: { textAlign: "center" },
        }),
        customBodyRender: (value: any, tableMeta: any) => {
          if (value) {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
    {
      name: "",
      label: "Action",
      options: {
        display: true,
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.rowData[0];

          return (
            //placement="right"
            <Tooltip title="Edit">
              <p className="ml-3">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    navigate("edit", {
                      state: { id },
                    });
                  }}
                >
                  <i className="fas fa-edit"></i>
                </a>
              </p>
            </Tooltip>
          );
        },
      },
    },
  ];
  const getDashboardData = async (btn) => {
    showLoader();
    let obj = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      RoleName:
        userRole && userRole.length > 0
          ? userRole.map(({ Id }) => Id).toString()
          : "",
      unitcodevalue:
        unitCode && unitCode.length > 0
          ? unitCode.map(({ value }) => value).toString()
          : "",
    };

    if (btn === "reset") {
      obj = {
        start: start,
        resultsPerPage: pageSize,
        searchText: searchText,
        sortColumn: sortColumn,
        sortDirection: sortDirection,
        RoleName: "",
        unitcodevalue: "",
      };
    }
    const resp = await APICall(getUserRoleMappingData, obj);

    if (resp?.Data?.Data.length > 0) {
      setDashboardData(resp?.Data?.Data);
      hideLoader();
    } else {
      setDashboardData([]);
      hideLoader();
    }
    setCount(
      resp?.Data?.Data?.[0]?.TotalCount || resp?.Data?.Data?.length || 0
    );
  };
  const exportToExcelFunction = async () => {
    const params = {
      resultsPerPage: count,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      RoleName:
        userRole && userRole.length > 0
          ? userRole.map(({ Id }) => Id).toString()
          : "",
      unitcodevalue:
        unitCode && unitCode.length > 0
          ? unitCode.map(({ value }) => value).toString()
          : "",
    };
    let token = await fetchAuthToken();
    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: getUserRoleMappingExporttoExcel,
        data: params,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
      
        fileDownload(
          response.data,
          `UserRoleMappingDashboardData_` +
            `${moment(new Date()).format(moment.HTML5_FMT.DATE)}` +
            `.xlsx`
        );
      })
      .catch((error) => {
      
        notify(ToastType.Error, "Failed to export data.");
      });
  };
  const selectOnChange = (event: any, apiFieldName: any) => {
    if (apiFieldName === "userRole") {
      setUserRole(event);
    }

    if (apiFieldName === "unitCode") {
      setUnitCode(event);
    }
  };
  const onClickFunction = async (event, action) => {
    if (action === "Apply") {
      let isEmptyReqObj = false;
      if (dashboardFilterOn === true) {
        let reqFilterObj = {
          userRole:
            userRole && userRole.length > 0
              ? userRole.map(({ value }) => value).toString()
              : "",
          unitcodevalue:
            unitCode && unitCode.length > 0
              ? unitCode.map(({ value }) => value).toString()
              : "",
        };
        isEmptyReqObj = Object.values(reqFilterObj).every((f) => {
          if (f === "" || f === null || f === undefined) {
            return true;
          } else {
            return false;
          }
        });
      }

      if (isEmptyReqObj === true) {
        notify(1, "Select at least one filter.");
      } else {
        await getDashboardData("");
      }
    } else if (action === "Reset") {
      await resetFunction();
    }
  };

  const resetFunction = async () => {
    setUserRole(null);
    setUnitCode(null);
    await getDashboardData("reset");
  };

  return (
    <>
      <div className="form-main">
        <div className="page-title w-100">
          <div className="col-lg-12 p-0">
            <div className="row justify-content-end">
              <div className="col-xl-3 col-lg-3 col-md-6 col-sm-12 SearchBoxUserRole">
                <div className="row d-flex justify-content-end mr-xl-2 mr-md-2">
                  <div className="col-lg-12 mt-1 p-0 searchInput">
                    <InputForm
                      value={searchText}
                      placeholder={"Search"}
                      isDisabled={false}
                      textArea={false}
                      onChange={(e) => {
                        setSearchText(e.target.value);
                      }}
                    />
                    <i className="fa fa-search ml-2" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 ml-2 usr_mob_pad">
                <div
                  className="float-right col-sm-offset-2 usr_mob"
                  style={{
                    marginBottom: 10,
                  }}
                >
                  <Tooltip title="Export to excel">
                    <button
                      className="btn btn-submit"
                      onClick={() => {
                        if (dashboardData.length === 0) {
                          notify(1, "No data available");
                        } else {
                          exportToExcelFunction();
                        }
                      }}
                    >
                      <i className="fa fa-download"></i>
                    </button>
                  </Tooltip>

                  <ButtonComponent
                    className="btn btn-submit"
                    style={{
                      marginLeft: 5,
                      cursor: "pointer",
                    }}
                    icon={"fas fa-plus-circle"}
                    value={"Create"}
                    onClick={() => {
                      navigate("edit", {
                        state: {
                          id: 0,
                        },
                      });
                    }}
                  />
                  <ul
                    className="float-right filter-icon "
                    style={{ position: "relative" }}
                  >
                    <li
                      onClick={() =>
                        setDashboardFilterOn((current) => !current)
                      }
                      className="filter-btn"
                    >
                      <a className="filter-btn">
                        <i className="fa fa-filter"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="page-content row filter-row-container mb-0 ml-0 mr-0">
        <div className="col-lg-12 p-0">
          <div className="row">
            <div className="col-lg-4 col-md-4"></div>
            <div className="col-lg-4 col-md-2"></div>
            <div className="col-lg-4 col-md-6">
              
            </div>
          </div>
        </div>
      </div> */}
      <div>
        <div className="clearfix"></div>
        <Collapse in={dashboardFilterOn}>
          <div className="filter-content ">
            <div className="row">
              <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                <div className="form-group">
                  <label className="col-form-label">User Role</label>
                  <SelectForm
                    options={userRoleOptions}
                    placeholder="Select User Role"
                    isDisabled={false}
                    value={userRole}
                    onChange={(event) => selectOnChange(event, "userRole")}
                    isMulti={true}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
              </div>
              <div className="col-lg-3 col-md-3 col-xs-12 mb-2">
                <div className="form-group">
                  <label className="col-form-label">Unit Code</label>
                  <SelectForm
                    options={unitCodeOptions}
                    placeholder="Select Unit Code"
                    isDisabled={false}
                    value={unitCode}
                    onChange={(event) => selectOnChange(event, "unitCode")}
                    isMulti={true}
                    noIndicator={false}
                    noSeparator={false}
                  />
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className="col-lg-12 col-md-12 mt-3"
                style={{ marginBottom: "15px" }}
              >
                <div className="float-right">
                  <button
                    className="btn btn-submit"
                    style={{ marginLeft: 5 }}
                    onClick={(e) => onClickFunction(e, "Apply")}
                  >
                    <i className="fas fa-check"></i>Apply
                  </button>
                  <button
                    className="btn btn-cancel"
                    style={{ marginLeft: 5 }}
                    onClick={(e) => onClickFunction(e, "Reset")}
                  >
                    <i className="fas fa-undo"></i> Reset
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Collapse>
        <DynamicGrid
          options={dashboardOptions}
          data={dashboardData}
          columns={dashboardGridColumns}
        />
      </div>
    </>
  );
};
export default UserRoleMappingDashboard;
